import { createFileRoute } from '@tanstack/react-router';
import { PreviewTemplateScreen } from '@/features/preparer/signature-templates/PreviewTemplateScreen';

export const Route = createFileRoute('/preparer/signature-templates/preview/$templateId')({
  component: PreviewTemplateScreen,
});
